export enum SelectedPage {
    Home = "home",
    Experience = "experience",
    Project = "project",
    Contact = "contact",
}